import { format } from 'date-fns';
import { pl } from 'date-fns/locale';
import { DateFormats } from '../enums';

export const formatDateToString = (date: Date | string | number, specificFormat: DateFormats): string => {
  if (date === null || date === undefined) return '';
  return format(date, specificFormat, { locale: pl });
};
